

































































































































































































import { Component, Mixins } from "vue-property-decorator";
import { DataTableHeader } from "vuetify/types/index";
import AxiosMixin from "@/mixins/axiosMixin";
import InviteChip from "@/components/master/staff/InviteChip.vue";
import CompleteChip from "@/components/master/staff/CompleteChip.vue";
import SearchPanel from "#/components/SearchPanel.vue";
import { Choice } from "@/types";
import { StaffItem } from "@/components/master/staff/types";
import { DefaultStaffSearchCondition } from "@/views/master/staff/types";
import { covid19VaccineStatuses } from "#/model/patient";
import OfficeSelect from "@/components/common_ibow/OfficeSelect.vue";
import UtilMixin from "@/mixins/utilMixin";
import * as constant from "#/const";

@Component({
  components: {
    InviteChip,
    CompleteChip,
    OfficeSelect,
    SearchPanel
  }
})
export default class StaffList extends Mixins(AxiosMixin, UtilMixin) {
  private headers: DataTableHeader[] = [
    {
      text: "",
      value: "button",
      width: "120px",
      align: "start",
      sortable: false
    },
    {
      text: "iBowID",
      value: "ibow_id",
      width: "140px"
    },
    {
      text: "職員名",
      value: "ibow_nickname",
      width: "160px"
    },
    {
      text: "事業所",
      value: "office_name",
      width: "256px"
    },
    {
      text: "職種",
      value: "staff_div_name",
      width: "90px"
    },
    {
      text: "状態",
      value: "status_name",
      width: "80px"
    },
    {
      text: "権限",
      value: "auth_name",
      width: "130px"
    },
    {
      text: "招待状況",
      value: "condition",
      width: "100px"
    },
    {
      text: "グループ",
      value: "group_icons",
      width: "100px"
    }
  ];

  // 検索サイドバーを開いているか
  private searchPanel = false;

  private pageNo = 1; //ページ番号

  private itemsPerPage = 25; //1ページあたりの項目数

  private items: StaffItem[] = []; //職員データ

  /** グループマスタ選択肢 */
  private groups: Choice[] = [];

  /** コロナワクチン接種状況選択肢 */
  private covid19VaccineStatuses = covid19VaccineStatuses;

  /** 職員一覧検索条件 */
  private staffSearchCondition = DefaultStaffSearchCondition();

  // 新規登録ボタン表示フラグ
  private get showNew(): boolean {
    return this.availableProcessing(
      constant.AGREEMENT.SETTING_ID_STAFF,
      constant.AGREEMENT.FUNCTION_DIV_INSERT
    );
  }

  // 絞り込みしているかどうか
  private get IsFiltered(): boolean {
    return !(
      this.staffSearchCondition.officeId === this.loginUser.office_id &&
      this.staffSearchCondition.status_zai === 1 &&
      this.staffSearchCondition.status_kyu === 0 &&
      this.staffSearchCondition.status_tai === 0 &&
      !this.staffSearchCondition.groupIds.find(id => id > 0) &&
      this.staffSearchCondition.covid19VaccineStatus === 0 &&
      this.staffSearchCondition.groupCondition === 1
    );
  }

  mounted() {
    if (typeof this.$route.query.keyword === "string") {
      this.staffSearchCondition.keyword = this.$route.query.keyword;
    }
    this.setDefaultSearch();
    this.updateData();
  }

  // デフォルトの検索条件を設定、クエリパラエータが優先
  private setDefaultSearch() {
    this.staffSearchCondition.officeId = this.loginUser.office_id;
    if (typeof this.$route.query.office_id === "string") {
      this.staffSearchCondition.officeId = Number(this.$route.query.office_id);
    }
    this.staffSearchCondition.status_zai = 1;
    if (typeof this.$route.query.status_zai === "string") {
      this.staffSearchCondition.status_zai = Number(
        this.$route.query.status_zai
      );
    }
    this.staffSearchCondition.status_kyu = 0;
    if (typeof this.$route.query.status_kyu === "string") {
      this.staffSearchCondition.status_kyu = Number(
        this.$route.query.status_kyu
      );
    }
    this.staffSearchCondition.status_tai = 0;
    if (typeof this.$route.query.status_tai === "string") {
      this.staffSearchCondition.status_tai = Number(
        this.$route.query.status_tai
      );
    }
    this.staffSearchCondition.orderby = 1;
    if (typeof this.$route.query.orderby === "string") {
      this.staffSearchCondition.orderby = Number(this.$route.query.orderby);
    }
    this.staffSearchCondition.orderbyType = 1;
    if (typeof this.$route.query.orderby_type === "string") {
      this.staffSearchCondition.orderbyType = Number(
        this.$route.query.orderby_type
      );
    }
    // グループ
    this.staffSearchCondition.groupIds = [0, 0, 0, 0, 0];
    if (this.$route.query.group_ids) {
      this.staffSearchCondition.groupIds = [];
      const groupIds = Array.isArray(this.$route.query.group_ids)
        ? this.$route.query.group_ids
        : [this.$route.query.group_ids];
      groupIds.forEach(groupId => {
        this.staffSearchCondition.groupIds.push(Number(groupId));
      });
    }
    // コロナワクチン接種状況
    this.staffSearchCondition.covid19VaccineStatus = 0;
    if (typeof this.$route.query.covid19_vaccine_status === "string") {
      this.staffSearchCondition.covid19VaccineStatus = Number(
        this.$route.query.covid19_vaccine_status
      );
    }
    // グループ検索条件
    this.staffSearchCondition.groupCondition = 1;
    if (typeof this.$route.query.group_condition === "string") {
      this.staffSearchCondition.groupCondition = Number(
        this.$route.query.group_condition
      );
    }
  }

  private updateData() {
    // 検索済みデータをリセット
    this.items = [];

    const statuses: number[] = [];
    // 在職
    let query_zai = "0";
    if (this.staffSearchCondition.status_zai) {
      statuses.push(1);
      query_zai = "1";
    }
    // 休職
    let query_kyu = "0";
    if (this.staffSearchCondition.status_kyu) {
      statuses.push(2);
      query_kyu = "1";
    }
    // 退職
    let query_tai = "0";
    if (this.staffSearchCondition.status_tai) {
      statuses.push(3);
      query_tai = "1";
    }
    // どのステータスも指定されなかった
    if (statuses.length == 0) {
      statuses.push(0);
    }

    // グループID
    const groupIds = this.staffSearchCondition.groupIds.map(groupId =>
      String(groupId)
    );

    //クエリパラメータにいれる
    this.$router.replace({
      query: {
        keyword: this.staffSearchCondition.keyword,
        status_zai: query_zai,
        status_kyu: query_kyu,
        status_tai: query_tai,
        orderby: String(this.staffSearchCondition.orderby),
        orderby_type: String(this.staffSearchCondition.orderbyType),
        office_id: String(this.staffSearchCondition.officeId),
        group_ids: groupIds,
        covid19_vaccine_status: String(
          this.staffSearchCondition.covid19VaccineStatus
        ),
        group_condition: String(this.staffSearchCondition.groupCondition)
      }
    });

    this.postJsonCheck(
      window.base_url + "/api/master/staff-list/get",
      {
        statuses: statuses,
        keyword: this.staffSearchCondition.keyword,
        orderby: this.staffSearchCondition.orderby,
        orderby_type: this.staffSearchCondition.orderbyType,
        office_id: this.staffSearchCondition.officeId,
        group_ids: this.staffSearchCondition.groupIds,
        covid19_vaccine_status: this.staffSearchCondition.covid19VaccineStatus,
        group_condition: this.staffSearchCondition.groupCondition
      },
      res => {
        this.items = res.data.staffs;
        this.groups = res.data.groups;
      }
    );
  }

  private clickRow(row: StaffItem) {
    this.$router.push({ name: "StaffEdit", params: { id: row.id.toString() } });
  }

  // シフト登録
  private clickShift(row: StaffItem) {
    this.$router.push({
      name: "MasterStaffShift",
      params: {
        staff_id: String(row.id),
        office_id: String(row.office_id)
      }
    });
  }

  //絞り込み
  private filterItems(value: unknown, search: string, item: StaffItem) {
    if (search == null) {
      return false;
    }

    if (item == null) {
      return false;
    }
    if (
      item.ibow_nickname.match(search) ||
      item.ibow_nickname_furigana.match(search) ||
      item.ibow_id.match(search) ||
      item.auth_name.match(search) ||
      item.office_name.match(search) ||
      item.staff_div_name.match(search) ||
      item.status_name.match(search)
    ) {
      return true;
    }

    return false;
  }

  /** ページ変更 */
  private changePage(pageNo: number) {
    this.pageNo = pageNo;
  }
}
